import apiClient from '@/utils/request'

import {
  IReplenishmentMethodsResponse,
  ISuggestReplenishmentData
} from '@/interfaces/replenishmentMethods'

export const fetchItems = async (): Promise<IReplenishmentMethodsResponse> => {
  const response = await apiClient.get<IReplenishmentMethodsResponse>(
    '/replenishment_containers'
  )
  return response.data
}

export const suggestReplenishment = async (
  payload: ISuggestReplenishmentData
): Promise<void> => {
  const response = await apiClient.post(
    '/replenishment_methods/suggest_replenishment',
    payload
  )
  return response.data
}
